export enum CmpConfigPublisherLegalBasis {
    CONSENT = "CONSENT",
    LEGITIMATE_INTEREST = "LEGITIMATE_INTEREST",
}
